import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';
import RoleListPage from '@features/roles/RoleListPage';

export const Route = createFileRoute('/t/roles/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdAt', sortDir: 'desc', tab: 'ALL' }),
  component: TenantRolesPage,
});

function TenantRolesPage() {
  const searchParams = Route.useSearch();
  return <RoleListPage routeTo="/t/roles" addRoute="/t/roles/add" searchParams={searchParams} />;
}
